/**
 * Asset actions
 */

import QueryString from "query-string";
import _merge from "lodash/merge";
import { Schemas, API } from "@thenounproject/lingo-core";

import * as actionTypes from "./actionTypes";

const { CALL_API } = API;

// Fetching
export function fetchItem(spaceId, uuid, version, assetToken) {
  const queryString = QueryString.stringify({
    asset_token: assetToken,
    v: version,
  });

  return {
    uuid: uuid,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_ITEM,
        actionTypes.FETCH_ITEM_SUCCESS,
        actionTypes.FETCH_ITEM_FAILURE,
      ],
      endpoint: `spaces/${spaceId}/items/${uuid}?${queryString}`,
      schema: Schemas.ITEM,
    },
  };
}

// Generate/fetch motion asset thumbnails
export function fetchMotionAssetThumbnails(uuid) {
  return {
    uuid: uuid,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_MOTION_ASSET_THUMBNAILS,
        actionTypes.FETCH_MOTION_ASSET_THUMBNAILS_SUCCESS,
        actionTypes.FETCH_MOTION_ASSET_THUMBNAILS_FAILURE,
      ],
      endpoint: `/assets/${uuid}/previews`,
      method: "GET",
      schema: null,
    },
  };
}

// Update motion asset thumbnail
export function updateMotionAssetThumbnail(uuid, thumbnail) {
  //use FormData if uploading custom thumbnail
  let imageData;
  if (!thumbnail.url) {
    const type = thumbnail.type.split("/")[1].toUpperCase();
    const formData = new FormData();
    formData.append("asset", thumbnail);
    formData.append("json", JSON.stringify({ type }));
    imageData = { formData };
  } else {
    imageData = { data: { filename: thumbnail.filename } };
  }
  return {
    uuid: uuid,
    [CALL_API]: {
      types: [
        actionTypes.UPDATE_MOTION_ASSET_THUMBNAIL,
        actionTypes.UPDATE_MOTION_ASSET_THUMBNAIL_SUCCESS,
        actionTypes.UPDATE_MOTION_ASSET_THUMBNAIL_FAILURE,
      ],
      endpoint: `/assets/${uuid}/preview`,
      method: "PUT",
      schema: Schemas.ASSET,
      ...imageData,
    },
  };
}

// Downloading

export function trackColorUsage(item, format) {
  const {
    id: itemId,
    version,
    asset: { shareToken },
  } = item;
  return {
    type: actionTypes.TRACK_COLOR_USAGE,
    itemId,
    version,
    format,
    shareToken,
  };
}
// Migrated to useGenerateFilecut
export function generateFileCut(item, fileType, dimensions, dpi) {
  const {
    id: itemId,
    assetId,
    version,
    asset: { shareToken, type: assetType },
  } = item;
  const queryString = QueryString.stringify({
    type: fileType,
    dimensions,
    dpi,
    asset_token: shareToken,
    response: "json",
  });
  return {
    itemId,
    version,
    dimensions,
    dpi,
    assetType,
    fileType: fileType,
    uuid: assetId,
    shareToken,
    propogateResponse: true,
    [CALL_API]: {
      types: [
        actionTypes.GENERATE_FILE_CUT,
        actionTypes.GENERATE_FILE_CUT_SUCCESS,
        actionTypes.GENERATE_FILE_CUT_FAILURE,
      ],
      endpoint: `assets/${assetId}/download?${queryString}`,
    },
  };
}

// Editing
export const saveAssetMetadata = (assetUuid, data) => {
  const validKeys = ["name", "notes", "keywords", "meta", "colors"],
    providedKeys = Object.keys(data),
    invalidKeys = providedKeys.filter(k => !validKeys.includes(k));

  if (invalidKeys.length > 0) {
    console.error(`Invalid asset metadata provided: ${JSON.stringify(invalidKeys)}`);
    return {
      type: actionTypes.SAVE_ASSET_METADATA_FAILURE,
    };
  }

  return {
    uuid: assetUuid,
    [CALL_API]: {
      types: [
        actionTypes.SAVE_ASSET_METADATA,
        actionTypes.SAVE_ASSET_METADATA_SUCCESS,
        actionTypes.SAVE_ASSET_METADATA_FAILURE,
      ],
      endpoint: `assets/${assetUuid}`,
      method: "PUT",
      schema: Schemas.ASSET,
      data: data,
    },
  };
};

export function fetchContentTypes(itemType, assetType) {
  const queryString = QueryString.stringify({
    item_type: itemType,
    type: assetType,
  });
  return {
    itemType,
    assetType,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_CONTENT_TYPES,
        actionTypes.FETCH_CONTENT_TYPES_SUCCESS,
        actionTypes.FETCH_CONTENT_TYPES_FAILURE,
      ],
      endpoint: `meta/content_types?${queryString}`,
      method: "GET",
    },
  };
}

/**
 * Retry asset processing for a file
 */
export function retryAssetFile(id) {
  return {
    [CALL_API]: {
      types: [
        actionTypes.RETRY_ASSET_FILE,
        actionTypes.RETRY_ASSET_FILE_SUCCESS,
        actionTypes.RETRY_ASSET_FILE_FAILURE,
      ],
      endpoint: `assets/${id}/process`,
      schema: Schemas.ASSET,
      method: "POST",
    },
  };
}
